import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Layout } from "antd";

const AppFooter = (props) => {
  const { Footer } = Layout;
  const navigate = useNavigate();

  const handleClear = () => {
    localStorage.removeItem("reqData");
    localStorage.removeItem("login");
    localStorage.removeItem("search");
    localStorage.setItem("reqData", JSON.stringify(props?.reqData));
    navigate("/");
  };

  return (
    <Footer style={{ textAlign: "center", opacity: "0.6" }}>
      Copyright 2024-2025 by Travelebrium{" "}
      <button className="clear-data-btn" onClick={() => handleClear()}>
        Clear Data
      </button>
    </Footer>
  );
};

export default AppFooter;
